import * as AntIcons from '@ant-design/icons';
import type React from 'react';

/**
 * Get Ant Design icon component from icon name string.
 * Backend sends Ant Design icon names like 'DashboardOutlined', 'DatabaseOutlined', etc.
 *
 * @param iconName - Name of the Ant Design icon as sent from backend
 * @returns React element of the icon or undefined if not found
 */
export function getIconComponent(iconName?: string): React.ReactElement | undefined {
  if (!iconName) return undefined;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const icons = AntIcons as any;
  const IconComponent = icons[iconName];

  if (!IconComponent) {
    console.warn(`Ant Design icon not found: ${iconName}`);
    return undefined;
  }

  return <IconComponent />;
}
